export const messages = {
  en: {
    couponPoolManage: {
      search: {
        title: 'Search Conditions',
        couponName: 'Please enter coupon name',
        validityDay: 'Please enter validity period'
      },
      list: {
        title: 'Coupon Pool Information',
        create: 'Create'
      },
      table: {
        poolId: 'Coupon Pool ID',
        couponType: 'Coupon Type',
        couponName: 'Coupon Name',
        actualPrice: 'Face Value',
        buyPrice: 'Purchase Price',
        couponStock: 'Quantity',
        validityDay: 'Validity Period',
        seq: 'Sequence',
        operation: 'Operation',
        edit: 'Edit'
      },
      add: {
        title: 'Add Coupon Pool',
        couponType: 'Coupon Type',
        selectCouponType: 'Please select coupon type',
        couponName: 'Coupon Name',
        inputCouponName: 'Required, please enter coupon name',
        actualPrice: 'Face Value',
        inputActualPrice: 'Required, please enter face value',
        buyPrice: 'Purchase Price',
        inputBuyPrice: 'Required, please enter purchase price',
        couponStock: 'Quantity',
        inputCouponStock: 'Required, please enter quantity',
        validityDay: 'Validity Period',
        inputValidityDay: 'Required, please enter validity period',
        seq: 'Sequence',
        inputSeq: 'Required, please enter sequence',
        cancel: 'Cancel',
        save: 'Save',
        success: 'Added successfully',
        error: 'Failed to add',
        couponTypeRequired: 'Coupon type is required',
        couponNameRequired: 'Coupon name is required',
        couponNameMaxLength: 'Coupon name cannot exceed 64 characters',
        actualPriceRequired: 'Face value is required',
        actualPriceMaxLength: 'Face value cannot exceed 10 characters',
        buyPriceRequired: 'Purchase price is required',
        buyPriceMaxLength: 'Purchase price cannot exceed 10 characters',
        couponStockRequired: 'Quantity is required',
        couponStockMaxLength: 'Quantity cannot exceed 20 characters',
        validityDayRequired: 'Validity period is required',
        validityDayMaxLength: 'Validity period cannot exceed 20 characters',
        seqRequired: 'Sequence is required',
        seqMaxLength: 'Sequence cannot exceed 11 characters'
      },
      edit: {
        title: 'Edit Coupon Pool',
        couponType: 'Coupon Type',
        couponName: 'Coupon Name',
        state: 'Status',
        selectState: 'Please select status',
        stateOff: 'Off Shelf',
        stateOn: 'Normal',
        actualPrice: 'Face Value',
        buyPrice: 'Purchase Price',
        couponStock: 'Quantity',
        validityDay: 'Validity Period',
        seq: 'Sequence',
        cancel: 'Cancel',
        save: 'Save',
        success: 'Updated successfully',
        error: 'Failed to update',
        buyPriceRequired: 'Purchase price is required',
        buyPriceMaxLength: 'Purchase price cannot exceed 10 characters',
        couponStockRequired: 'Quantity is required',
        couponStockMaxLength: 'Quantity cannot exceed 20 characters',
        stateRequired: 'Status is required'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this coupon?',
        cancel: 'Cancel',
        confirmDelete: 'Confirm Delete',
        success: 'Deleted successfully',
        error: 'Failed to delete'
      },
      fetchError: 'Failed to fetch coupon pool data'
    }
  },
  zh: {
    couponPoolManage: {
      search: {
        title: '查询条件',
        couponName: '请输入优惠券名称',
        validityDay: '请输入有效期'
      },
      list: {
        title: '优惠券池信息',
        create: '制作'
      },
      table: {
        poolId: '优惠券池ID',
        couponType: '优惠券类型',
        couponName: '优惠券名称',
        actualPrice: '面值',
        buyPrice: '购买价格',
        couponStock: '数量',
        validityDay: '有效期',
        seq: '排序',
        operation: '操作',
        edit: '修改'
      },
      add: {
        title: '添加优惠券池',
        couponType: '优惠券类型',
        selectCouponType: '请选择优惠券类型',
        couponName: '优惠券名称',
        inputCouponName: '必填，请填写优惠券名称',
        actualPrice: '面值',
        inputActualPrice: '必填，请填写面值',
        buyPrice: '购买价格',
        inputBuyPrice: '必填，请填写购买价格',
        couponStock: '数量',
        inputCouponStock: '必填，请填写数量',
        validityDay: '有效期',
        inputValidityDay: '必填，请填写有效期',
        seq: '排序',
        inputSeq: '必填，请填写排序',
        cancel: '取消',
        save: '保存',
        success: '添加成功',
        error: '添加失败',
        couponTypeRequired: '优惠券类型不能为空',
        couponNameRequired: '优惠券名称不能为空',
        couponNameMaxLength: '优惠券名称不能超过64',
        actualPriceRequired: '面值不能为空',
        actualPriceMaxLength: '面值不能超过10',
        buyPriceRequired: '购买价格不能为空',
        buyPriceMaxLength: '购买价格不能超过10',
        couponStockRequired: '数量不能为空',
        couponStockMaxLength: '数量不能超过20',
        validityDayRequired: '有效期不能为空',
        validityDayMaxLength: '有效期不能超过20',
        seqRequired: '排序不能为空',
        seqMaxLength: '排序不能超过11'
      },
      edit: {
        title: '修改优惠券池',
        couponType: '优惠券类型',
        couponName: '优惠券名称',
        state: '券状态',
        selectState: '请选择券状态',
        stateOff: '下架',
        stateOn: '正常',
        actualPrice: '面值',
        buyPrice: '购买价格',
        couponStock: '数量',
        validityDay: '有效期',
        seq: '排序',
        cancel: '取消',
        save: '保存',
        success: '修改成功',
        error: '修改失败',
        buyPriceRequired: '购买价格不能为空',
        buyPriceMaxLength: '购买价格不能超过10',
        couponStockRequired: '数量不能为空',
        couponStockMaxLength: '数量不能超过20',
        stateRequired: '券状态不能为空'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除优惠券',
        cancel: '点错了',
        confirmDelete: '确认删除',
        success: '删除成功',
        error: '删除失败'
      },
fetchError: '获取优惠券池数据失败'
    }
  },
  'zh-TW': {
    couponPoolManage: {
      search: {
        title: '查詢條件',
        couponName: '請輸入優惠券名稱',
        validityDay: '請輸入有效期'
      },
      list: {
        title: '優惠券池信息',
        create: '製作'
      },
      table: {
        poolId: '優惠券池ID',
        couponType: '優惠券類型',
        couponName: '優惠券名稱',
        actualPrice: '面值',
        buyPrice: '購買價格',
        couponStock: '數量',
        validityDay: '有效期',
        seq: '排序',
        operation: '操作',
        edit: '修改'
      },
      add: {
        title: '添加優惠券池',
        couponType: '優惠券類型',
        selectCouponType: '請選擇優惠券類型',
        couponName: '優惠券名稱',
        inputCouponName: '必填，請填寫優惠券名稱',
        actualPrice: '面值',
        inputActualPrice: '必填，請填寫面值',
        buyPrice: '購買價格',
        inputBuyPrice: '必填，請填寫購買價格',
        couponStock: '數量',
        inputCouponStock: '必填，請填寫數量',
        validityDay: '有效期',
        inputValidityDay: '必填，請填寫有效期',
        seq: '排序',
        inputSeq: '必填，請填寫排序',
        cancel: '取消',
        save: '保存',
        success: '添加成功',
        error: '添加失敗',
        couponTypeRequired: '優惠券類型不能為空',
        couponNameRequired: '優惠券名稱不能為空',
        couponNameMaxLength: '優惠券名稱不能超過64',
        actualPriceRequired: '面值不能為空',
        actualPriceMaxLength: '面值不能超過10',
        buyPriceRequired: '購買價格不能為空',
        buyPriceMaxLength: '購買價格不能超過10',
        couponStockRequired: '數量不能為空',
        couponStockMaxLength: '數量不能超過20',
        validityDayRequired: '有效期不能為空',
        validityDayMaxLength: '有效期不能超過20',
        seqRequired: '排序不能為空',
        seqMaxLength: '排序不能超過11'
      },
      edit: {
        title: '修改優惠券池',
        couponType: '優惠券類型',
        couponName: '優惠券名稱',
        state: '券狀態',
        selectState: '請選擇券狀態',
        stateOff: '下架',
        stateOn: '正常',
        actualPrice: '面值',
        buyPrice: '購買價格',
        couponStock: '數量',
        validityDay: '有效期',
        seq: '排序',
        cancel: '取消',
        save: '保存',
        success: '修改成功',
        error: '修改失敗',
        buyPriceRequired: '購買價格不能為空',
        buyPriceMaxLength: '購買價格不能超過10',
        couponStockRequired: '數量不能為空',
        couponStockMaxLength: '數量不能超過20',
        stateRequired: '券狀態不能為空'
      },
      delete: {
        title: '請確認您的操作',
        confirm: '確定刪除優惠券',
        cancel: '點錯了',
        confirmDelete: '確認刪除',
        success: '刪除成功',
        error: '刪除失敗'
      },
      fetchError: '獲取優惠券池數據失敗'
    }
  }
}